import { CancelReasons, CostCategory, ShiftType, UserStatus } from '@velove/types';

/**
 * Get label to display for a given CancelReasons
 */
export function getCancelationReasonLabel(reason: CancelReasons): string {
  switch (reason) {
    case CancelReasons.SICKNESS:
      return 'Sickness or injury (deprecated)';
    case CancelReasons.OTHER:
      return 'Other (deprecated)';
    case CancelReasons.CANCELLED_BY_PARTNER:
      return 'Cancelled by Partner';
    case CancelReasons.CANCELLED_BY_STANDBY:
      return 'Cancelled by Standby';
    case CancelReasons.CANCELLED_BY_VELOVE:
      return 'Cancelled by Velove';
    case CancelReasons.CARE_OF_CHILDREN:
      return 'Care of children';
    case CancelReasons.PARENTAL_LEAVE:
      return 'Parental Leave';
    case CancelReasons.INVALID_ABSENCE:
      return 'Invalid Absence';
    case CancelReasons.SE_SICKNESS_DAY_1_SHIFT_1:
      return 'Sweden sickness day 1 (1 Shift p/w)';
    case CancelReasons.SE_SICKNESS_DAY_1_SHIFTS_2:
      return 'Sweden sickness day 1 (2 Shifts p/w)';
    case CancelReasons.SE_SICKNESS_DAY_1_SHIFTS_3:
      return 'Sweden sickness day 1 (3 Shifts p/w)';
    case CancelReasons.SE_SICKNESS_DAY_1_SHIFTS_4:
      return 'Sweden sickness day 1 (4 Shifts p/w)';
    case CancelReasons.SE_SICKNESS_DAY_1_SHIFTS_5_PLUS:
      return 'Sweden sickness day 1 (5+ Shifts p/w)';
    case CancelReasons.SE_SICKNESS_DAY_2_PLUS:
      return 'Sweden sickness day 2+';
  }
}

/**
 * Get label to display for a given CostCategory
 */
export function getCostCategoryLabel(costCategory?: CostCategory | string | null): string {
  switch (costCategory) {
    case CostCategory.CANCELLED_BY_US:
      return 'Cancelled by us';
    case CostCategory.CANCELLED_BY_CUSTOMERS:
      return 'Cancelled by customers';
    case CostCategory.CLEANING:
      return 'Cleaning';
    case CostCategory.PROJECTS:
      return 'Projects';
    case CostCategory.MARKETING:
      return 'Marketing';
    case CostCategory.MOTIVATION_INCENTIVES:
      return 'Motivation Incentives';
    case CostCategory.REFERRALS:
      return 'Referrals';
    case CostCategory.HELPING_OPERATIONS:
      return 'Helping Operations';
    case CostCategory.HELPING_COMMUNITY:
      return 'Helping Community';
    case CostCategory.STANDBY_SHIFT:
      return 'Stand-By Shift';
    case CostCategory.DIFF:
      return 'Diff';
    case CostCategory.OTHER:
      return 'Other';
  }

  return '-';
}

/**
 * Get label to display for a given ShiftType
 */
export function getShiftTypeLabel(type: ShiftType): string {
  switch (type) {
    case ShiftType.DELIVERY:
      return 'Delivery';
    case ShiftType.MANAGER:
      return 'Shift Manager';
    case ShiftType.LOADING:
      return 'Loading Manager';
    case ShiftType.MAINTENANCE:
      return 'Maintenance';
    case ShiftType.INSTRUCTOR:
      return 'Instructor';
    case ShiftType.BUDDY:
      return 'Buddy';
    case ShiftType.TRAINING:
      return 'Training';
    case ShiftType.SUPPORT:
      return 'Support';
    case ShiftType.CLEANING:
      return 'Cleaning';
    case ShiftType.SORTER:
      return 'Sorter';
    case ShiftType.LINEHAUL:
      return 'Linehaul';
    case ShiftType.MANAGEMENT_HR:
      return 'MANAGEMENT(HR)';
    case ShiftType.MANAGEMENT_OPERATIONS:
      return 'MANAGEMENT(OPERATIONS)';
    case ShiftType.MANAGEMENT_OTHER:
      return 'MANAGEMENT(OTHER)';
    case ShiftType.TRAFFIC_CONTROL_TEAM:
      return 'Traffic Control Team';
    case ShiftType.OTHER:
      return 'Other';
  }
}

/**
 * Get label to display for a given UserStatus
 */
export function getUserStatusLabel(status: UserStatus): string {
  switch (status) {
    case UserStatus.AVAILABLE:
      return 'Available';
    case UserStatus.BREAK:
      return 'Break';
    case UserStatus.SUSPENDED:
      return 'Suspended';
    case UserStatus.QUIT:
      return 'Quit';
  }
}
